define(function (require) {

    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');
    var Handlebars = require('handlebars');
    var _ = require('underscore');

    var Template_select = require('text!popovers/filter/template/filter_select_item.tpl').default;
    var Template_custom_select = require('text!popovers/filter/template/filter_custom_select_item.tpl').default;
    var TemplateCurrentItem = require('text!popovers/filter/template/filter_current_item.tpl').default;

    function isArray(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    }

    function isFunction(obj) {
        return Object.prototype.toString.call(obj) === '[object Function]';
    }

    function isObject(obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    }
    /*
     *	Модель поля фильтра
     */
    var ModelFilterItem = Backbone.Model.extend({
        defaults: function () {
            return {
                hash: '',
                type: '',
                title: '',
                active: 0
            };
        }
    });

    /*
     *	Коллекция полей фильтра
     */
    var CollectionFilter = Backbone.Collection.extend({
        model: ModelFilterItem
    });


    /*
     *	Объект фильтра
     */
    var Filter = {
        /**
         * Набор фильтров при первом открытии
         */
        initFilter: {},

        // Поля фильтров
        items: {},

        // Коллекции полей фильтров
        collection: {},

        // Выбранные значения фильтров
        values: {},

        // Callbacks
        callback: {},

        onFilterCallback: {},
        onAddFilterCallback: {},
        onRemoveFilterCallback: {},

        // Количество выбранных фильтров
        selected: {},

        // Префиксы для формирования строки
        prefix: {},

        /*
         *	Инициализация нового фильтра
         *	@param {object} options
         */
        init: function (options) {
            var that = this;
            var hash = options.hash;

            // Clear method
            var clear = false;
            if (options['clear'] && options['clear'] == true) {
                clear = true;
            }
            if (clear) {
                that.init_clear(hash);
            }

            // Инициализация полей фильтра
            that.init_item(hash, options.items);
            // Инициализация коллекции полей фильтра
            that.init_collection(hash, options.items);
            that.init_values(hash, options);
            that.init_callback(hash, options);

            // Ставим количество выбранных фильтров в 0
            if (clear) {
                that.selected[hash] = 0;
            }

            if (options.hasOwnProperty('prefix')) {
                that.prefix[hash] = options.prefix;
            }

            if (typeof that.initFilter[hash] != "undefined") {
                that.set_json(hash, that.initFilter[hash]);
                delete that.initFilter[hash];
            }

            if (!clear) {
                that.trigger(hash, false);
            }
        },

        /**
         *	function init_clear()
         *	Clear when reinit
         *	@param 	{string}	hash
         */
        init_clear: function (hash) {
            var that = this;

            that.items[hash] = {};
            that.values[hash] = {};
            that.selected[hash] = 0;
        },

        /*
         *	Инициализация значений фильтра
         */
        init_values: function (hash, options) {
            var that = this;

            var clear = false;
            if (options['clear'] && options['clear'] == true) {
                clear = true;
            }
            if (clear) {
                that.values[hash] = {};
            } else {
                if (!that.values[hash]) {
                    that.values[hash] = {};
                }
            }
        },

        /*
         *	Инициализация callback
         *	@param {string} hash
         *	@param {object} options
         */
        init_callback: function (hash, options) {
            var that = this;

            if (options.hasOwnProperty('initialize') && isFunction(options.initialize)) {
                options.initialize.apply(that);
            }

            if (options.hasOwnProperty('onChange') && isFunction(options.onChange)) {
                that.addListener(hash, options.onChange)
            }

            if (options.hasOwnProperty('onFilter') && isFunction(options.onFilter)) {
                this.onFilterCallback[hash] = options.onFilter;
            }

            if (options.hasOwnProperty('onAddFilterItem') && isFunction(options.onAddFilterItem)) {
                this.onAddFilterCallback[hash] = options.onAddFilterItem;
            }
            if (options.hasOwnProperty('onRemoveFilterItem') && isFunction(options.onRemoveFilterItem)) {
                this.onRemoveFilterCallback[hash] = options.onRemoveFilterItem;
            }

        },


        /*
         *	Метод для добавления событий
         *	@param {string} hash
         *	@param {Function} callback
         */
        addListener: function (hash, callback) {
            var that = this;
            if (!isArray(that.callback[hash])) {
                that.callback[hash] = [];
            }
            that.callback[hash].push(callback);
        },

        /*
         *	Инициализация полей фильтра
         *	@param {string} hash
         *	@param {array|object} items
         */
        init_item: function (hash, items, parent) {
            var that = this;
            var item;

            parent = parent || {};

            if (isArray(items)) {
                _.each(items, function (item) {
                    that.init_item(hash, _.clone(item));
                });
            } else {
                if (!that.items.hasOwnProperty(hash)) {
                    that.items[hash] = {};
                }
                item = _.clone(items);
                that.items[hash][item.hidden] = _.extend(item, {
                    parent: parent.hidden || false,
                    child: (item.hasOwnProperty('child') ? item.child.hidden : false)
                });
                if (items.hasOwnProperty('child')) {
                    that.init_item(hash, items.child, items);
                }
            }
        },

        /*
         *	Инициализация коллекции полей фильтра
         *	@param {string} hash
         */
        init_collection: function (hash, items) {
            var that = this;
            var collection = new CollectionFilter;

            collection.add(new ModelFilterItem({
                hash: hash,
                hidden: 'filters_selected',
                type: 'filters_selected',
                title: I18n.Filter.filters_selected,
                active: 1,
                counter: 0
            }));
            _.each(items, function (item) {
                collection.add(new ModelFilterItem(_.extend(item, {
                    hash: hash,
                    active: 0,
                    counter: 0
                })));
            });

            that.collection[hash] = collection;
        },

        /*
         *	Метод для получения коллекции полей фильтра по hash
         *	@param {string} hash
         *	@return {Backbone.Collection} collection
         */
        get_collection: function (hash) {
            var that = this;
            return that.collection[hash];
        },

        /*
         *	Метод для генерации select-ов
         *	@param {object} options
         */
        create_select: function (hash, options) {
            var that = this;
            var view = options.view;
            var select = that.items[hash][options.hidden];
            var parent = options.parent || false;

            // ui - elements
            var zones = view.$el.find('.select_zones');
            var parent_zone = (parent ? view.$el.find('#select_zone_' + parent.hidden + '_' + parent.id) : zones);
            var template = Handlebars.compile(options.custom ? Template_custom_select : Template_select);

            var items_list = [];
            var items = select.items;
            var hidden = select.hidden;
            var emptyText = 'Ничего не найдено';
            var errText = options.errText || emptyText;

            var _deferred = $.Deferred();

            if (items && isArray(items) && items.length == 0) {
                _deferred.resolve('Нет элементов для выбора');
            } else if (items && isFunction(items)) {
                $.when(items()).then(function(result) {
                    if (result.length == 0) {
                        _deferred.resolve('Нет элементов для выбора');
                    } else {
                        items_list = result;
                        _deferred.resolve();
                    }
                })
            } else if (items == undefined || !isArray(items) || (isArray(items) && items.length == 0)) {
                if (select.url !== undefined) {

                    var url = select.url;
                    var sim;
                    
                    if (select.appendIdToUrl) {
                        url += '/' + parent.id;
                    } else if (parent) {
                        if (url.indexOf('?') === -1) {
                            sim = '?';
                        } else {
                            sim = '&';
                        }
                        url += sim + ((select.relation) ? select.relation : 'cid') + '=' + parent.id;
                    }
                    Backbone.ajax({
                        type: 'GET',
                        //url: select.url + (parent ? ('&'+((select.relation)?select.relation:'cid')+'='+parent.id) : ''),
                        url: url,
                        dataType: 'json'
                    }).done(function (response) {
                        if (response.status == undefined || response.status == 1) {
                            //items_list = response.items;
                            if (response.status == undefined) {
                                items_list = response;
                            } else if (response.result !== undefined) {
                                items_list = response.result.data;
                            }
                        } else {
                            // no items found
                        }

                        _deferred.resolve(emptyText);
                    }).fail(function(response) {
                        _deferred.resolve(errText);
                    });
                }
            } else {
                items_list = items;
                _deferred.resolve();
            }

            $.when(_deferred).done(function (text) {
                var select_options = [];
                var select_text = [];
                if(that.isDestroyed) {
                    return;
                }
                if (items_list && items_list.length > 0) {
                    _.each(items_list, function (item) {
                        select_options.push({
                            id: item.id,
                            text: item.name
                        });
                        select_text[item.id] = item.name;
                    });
                }

                var parentId = parent.id;
                if (select.oneValue) {
                    parentId = '';
                }

                var wrap_id = 'wrap_'+hidden+(parent ? ('_'+parentId) : '');
                var select_id = 'select_'+hidden+(parent ? ('_'+parentId) : '');

                if (select.oneValue) {
                    var $wrapper = $('#' + wrap_id),
                        $selector = $('#'+select_id);

                    select_options.unshift({id: '', text: ''});

                    if ($wrapper.length) {
                        if ($selector.length) {
                            $selector.select2('destroy').remove();
                        }
                        $wrapper.remove();
                    }
                }
                var html = template({
                    wrap_id: wrap_id,
                    label: select.title + (parent ? (' "' + parent.text + '"') : '')
                });
                parent_zone.append(html);
                var wrap = $('#' + wrap_id);


                var select_ui = $('<select/>',{
                    'id'	: select_id,
                    'class'	: 'select2',
                    'width' : '100%'
                }).appendTo(wrap.find('.control_wrap'));

                var select2Options = {
                    multiple: (typeof select.select2Multiple === 'undefined') ? true : select.select2Multiple,
                    closeOnSelect: false,
                    scrollAfterSelect: false,
                    placeholder: select.title,
                    width: 'resolve',
                    dropdownParent: view.$el.closest('.b-table-filter').length ? view.$el.closest('.b-table-filter') : $(document.body),
                    data: select_options,
                    'language': {
                        'noResults': function () {
                            return text;
                        }
                    }
                };

                if (select.options) {
                    _.extend(select2Options, select.options)
                }

                $('#' + select_id).select2(select2Options);

                var selected_values = _.compact(that.get_value(hash, {
                    hidden 	: select.hidden,
                    parent 	: (parent ? parentId : false)
                }));

                if (selected_values.length > 0) {
                    var set_values = [];
                    _.each(selected_values, function (sv) {
                        set_values.push(sv.id);
                    });
                    select_ui.val(set_values).trigger('change');

                    if(select.child){
                        _.each(selected_values, function(item){
                            var zone_id = 'select_zone_'+select.hidden+'_'+item.id;
                            if (['=', '<>', '>', '<'].indexOf(item.id) >= 0) {
                                return;
                            }
                            $('<div/>', {
                                'id': zone_id,
                                'class': 'select_zone'
                            }).appendTo(parent_zone);

                            that.create_select(hash, _.extend({}, options, {
                                custom: false,
                                hidden: select.child,
                                parent: {
                                    id: item.id,
                                    text: item.text,
                                    hidden: select.hidden
                                }
                            }));
                        });
                    }
                }

                if(options.custom) {
                    var condition = _.find(selected_values, function(value) {
                        return ['<>', '=', '>', '<'].indexOf(value.id) >= 0;
                    });
                    if (condition) {
                        $('input[name=' + wrap_id + '][value="' + condition.id + '"]').click();
                    }
                    $('.js-contains-label_' + wrap_id).click(function () {
                        $('input[name="' + wrap_id + '"]').click();
                        //if(select_ui.val()) {
                            setTimeout(function() {
                                var conditions = that.values[hash][select.hidden];
                                conditions = _.filter(conditions, function(condition) {
                                    return ['<>', '=', '>', '<'].indexOf(condition.id) < 0;
                                });
                                var newConditionItem = {
                                    id: $('input[name="' + wrap_id + '"]:checked').val(),
                                    text: $('input[name="' + wrap_id + '"]:checked').val(),
                                    hidden: select.hidden
                                };
                                conditions.push(newConditionItem);
                                that.values[hash][select.hidden] = conditions;
                                if(select_ui.val()) {
                                    that.trigger(hash);
                                }
                            })
                        //}
                    });
                }

                // Событие когда в селекте выбирается новый пункт
                select_ui.on('select2:select', function (event) {
                    var data = event.params.data;

                    if(options.custom) {
                        that.set_value(hash, {
                            value: {
                                id: $('input[name="' + wrap_id + '"]:checked').val(),
                                text: $('input[name="' + wrap_id + '"]:checked').val(),
                                hidden: select.hidden,
                            },
                        }, false);
                    }
                        that.set_value(hash, {
                            value: {
                                id: data.id,
                                text: data.text,
                                hidden: select.hidden
                            },
                            parent: (parent ? parent.id : false)
                        });
                    //}
                    if(select.child){
                        var zone_id = 'select_zone_'+select.hidden+'_'+data.id;
                        if (['=', '<>', '>', '<'].indexOf(data.id) >= 0) {
                            return;
                        }
                        if ($('#' + zone_id).length == 0) {
                            $('<div/>', {
                                'id': zone_id,
                                'class': 'select_zone'
                            }).appendTo(parent_zone);
                        }

                        that.create_select(hash, _.extend({}, options, {
                            custom: false,
                            hidden: select.child,
                            parent: {
                                id: data.id,
                                text: data.text,
                                hidden: select.hidden
                            }
                        }));
                    }

                    // !! TODO
                    // trigger change
                    if (hash == 'leads' || hash == 'deals') {
                        $('.b-sidebar-view__add').removeClass('hide').show();
                        $('.b-sidebar-view.active').removeClass('active');
                    }
                    if (app.curPage && app.curPage.filterId) app.curPage.filterId = false;
                });

                select_ui.on('select2:unselect', function (event) {
                    var data = event.params.data;
                    var zone_id = 'select_zone_' + select.hidden + '_' + data.id;

                    that.remove_value(hash, {
                        hidden 	: select.hidden,
                        value 	: data.id,
                        parent 	: (parent ? parentId : false)
                    });
                    $('#' + zone_id).remove();

                    // !! TODO
                    // trigger change
                    if (hash == 'leads' || hash == 'deals') {
                        $('.b-sidebar-view__add').removeClass('hide').show();
                        $('.b-sidebar-view.active').removeClass('active');
                    }
                    if (typeof app.curPage != "undefined" && typeof app.curPage.filterId != "undefined") {
                        app.curPage.filterId = false;
                    }

                });
            });
            return _deferred;
        },

        /*
         *	Метод для получения выбранных значений
         *	@param {string} hash
         *	@param {object} options
         *	@return {array} values
         */
        get_value: function (hash, options) {
            var that = this;
            var hidden = options.hidden;
            var parent = options.parent;
            var values = [];

            if (!that.values[hash].hasOwnProperty(hidden)) {
                that.values[hash][hidden] = [];
            }
            if (!parent) {
                values = that.values[hash][hidden];
            } else {
                values = _.filter(that.values[hash][hidden], function(item) {
                    return item && item.parent == parent;
                });
            }

            return values;
        },

        /*
         *	Метод установки нового значения поля фильтра
         *	@param {string} hash
         *	@param {object} options
         */
        set_value: function (hash, options, trigger_value) {
            var that = this;
            var value = options.value;
            var parent = options.parent || false;
            //trigger = trigger || true;
            var trigger = true;
            if (trigger_value !== undefined) {
                trigger = trigger_value;
            }

            if (typeof that.values[hash] === 'string') {
                that.values[hash] = JSON.parse(that.values[hash]);
            }

            if (!that.values[hash].hasOwnProperty(value.hidden)) {
                that.values[hash][value.hidden] = [];
            }
            if(!parent){
                if (that.items[ hash ][ value.hidden ]) {
                    if(that.items[ hash ][ value.hidden ].type == 'select'){
                        if (that.items[ hash ][ value.hidden ].oneValue) {
                            that.values[ hash ][ value.hidden ] = [];
                        }
                        if(!_.findWhere(that.values[ hash ][ value.hidden], {id:value.id})) {
                            that.values[hash][value.hidden].push(value);
                        }
                    }else{
                        var len = that.values[ hash ][ value.hidden ].length;

                        if (value.index == 1 && len == 0) {
                            that.values[hash][value.hidden][0] = '';
                        }
                        that.values[hash][value.hidden][value.index] = value.text;
                    }
                }
            } else {
                var valueIndex = _.findIndex(that.values[hash][value.hidden], {id:value.id});
                if ( valueIndex < 0) {
                    that.values[hash][value.hidden].push(_.extend(value, {
                        parent: parent
                    }));
                } else {
                    that.values[hash][value.hidden][valueIndex] = _.extend(value, {
                        parent: parent
                    });
                }
            }

            if (typeof that.onAddFilterCallback[hash] !== "undefined") {
                that.onAddFilterCallback[hash].call(null);
            }

            if (trigger) {
                that.trigger(hash);
            }
            if (hash == 'leads' || hash == 'deals') {
                this.toggleNewFilterArea();                 //TODO убрать из фильтра взаимодействие с ui
            }
        },

        toggleNewFilterArea: function () {
            if ($('.b-sidebar-view.active').length)
                this.hideFilterArea();
            else
                this.showFilterArea();
        },

        showFilterArea: function () {
            $('.b-sidebar-view__add').removeClass('hide').show();
        },

        hideFilterArea: function () {
            $('.b-sidebar-view__add').hide();
            //$('.b-sidebar-view__save').hide();
        },

        /*
         *	Метод удаления значения из выбранных
         *	@param {string} hash
         *	@param {object|undefined} options
         */
        remove_value: function (hash, options) {
            var that = this;

            options = options || false;
            var values = [];

            if (options) {
                var hidden = options.hidden;
                var value = options.value;
                var parent = options.parent;

                var reverse = options.reverse || false;
            }
            var vhash = JSON.stringify(that.values[hash]);

            if (!options) {
                that.values[hash] = {};
                if (vhash != JSON.stringify(that.values[hash])) {
                    that.trigger(hash, 'change');
                }
                return;
            } else {
                if (reverse) {
                    values = [value];
                } else {
                    if (parent == undefined || parent == '') {
                        values = [value];
                        if (that.values[hash].hasOwnProperty(hidden)) {
                            if (isArray(that.values[hash][hidden])) {
                                for (var i in that.values[hash][hidden]) {
                                    if (that.values[hash][hidden].hasOwnProperty(i)) {
                                        var v = that.values[hash][hidden][i];
                                        if (v && (!value || v.id == value)) {
                                            that.values[hash][hidden].splice(i, 1);
                                        }
                                    }
                                }
                            }
                            if (_.compact(that.values[hash][hidden]).length == 0) {
                                delete that.values[hash][hidden];
                            }
                        }
                    } else {
                        if (that.values[hash].hasOwnProperty(hidden)) {
                            var hasChildren;
                                values = [];
                            that.values[hash][hidden] = _.reject(that.values[hash][hidden], function (v, i) {
                                    if (v.parent == parent) {
                                        hasChildren = true;
                                        if (!reverse) {
                                            values.push(v.id);
                                        }
                                        if (v.id == value) {
                                            if (reverse) {
                                                values.push(v.id);
                                            }
                                        }
                                    }
                                    return (v.parent == parent && (!value || v.id == value));
                                });
                            if (!hasChildren){
                                if (vhash != JSON.stringify(that.values[hash])) {
                                    that.trigger(hash, 'change');
                                }
                                return;
                            }
                        }
                    }
                }

                if (values.length > 0) {
                    if (reverse) {
                        var value_src = value;

                        var recurse_delete = function (hidden, value, parent) {

                            if (that.items[hash][hidden].type == 'select') {
                                if (!that.items[hash][hidden].child) {
                                    if (that.values[hash].hasOwnProperty(hidden)) {
                                        if (parent == undefined || parent == '') {
                                            if (isArray(that.values[hash][hidden])) {
                                                that.values[hash][hidden] = _.reject(that.values[hash][hidden], function(item) {
                                                    if (that.items[hash][hidden].parent) {
                                                        recurse_delete(that.items[hash][hidden].parent, item.parent);
                                                    }
                                                    return !value || item.id == value;
                                                });
                                            }
                                        } else {
                                            that.values[hash][hidden] = _.reject(that.values[hash][hidden], function(item) {
                                                if (that.items[hash][hidden].parent) {
                                                    recurse_delete(that.items[hash][hidden].parent, item.parent);
                                                }
                                                return (item.parent == parent && (!value || item.id == value));
                                            });
                                        }
                                    }
                                } else {
                                    var parent = false;
                                    if (that.values[hash].hasOwnProperty(hidden)) {
                                        if (isArray(that.values[hash][hidden])) {
                                            _.each(that.values[hash][hidden], function (array, index) {
                                                if (isArray(array)) {
                                                    _.each(array, function (ai, ai_index) {
                                                        if (isObject(ai) && !value || ai.id == value) {
                                                            parent = index;
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    }
                                    if (!parent) {
                                        if (isArray(that.values[hash][hidden])) {
                                            that.values[hash][hidden] = _.reject(that.values[hash][hidden], function(item) {
                                                return item && (!value || item.id == value);
                                            });
                                        }
                                    } else {
                                        if (isArray(that.values[hash][hidden])) {
                                            that.values[hash][item_hidden] = _.reject(that.values[hash][item_hidden], function(item) {
                                                return (item.parent == parent && (!value || item.parent == item.id));
                                            });
                                        }
                                    }
                                }
                            } else {
                                // date || integer
                                delete that.values[hash][hidden];
                            }
                        };
                        recurse_delete(hidden, value, parent);
                    } else {
                        while (that.items[hash][hidden].child) {
                            _.each(values, function (v) {
                                if (that.values[hash].hasOwnProperty(that.items[hash][hidden].child)) {
                                    if (isArray(that.values[hash][that.items[hash][hidden].child][v])) {
                                        var values2 = [];
                                        _.each(that.values[hash][that.items[hash][hidden].child][v], function (item) {
                                            values2.push(item.id);
                                        });
                                        values = values2;
                                        delete that.values[hash][that.items[hash][hidden].child][v];
                                    }
                                }
                            });
                            if (_.compact(that.values[hash][that.items[hash][hidden].child]).length == 0) {
                                delete that.values[hash][that.items[hash][hidden].child];
                            }
                            hidden = that.items[hash][hidden].child;
                        }
                    }
                }
            }
            if (vhash != JSON.stringify(that.values[hash])) {
                that.trigger(hash, 'change');
            }

            if (typeof (that.onFilterCallback[hash]) != 'undefined') {
                that.onFilterCallback[hash].call(null);
            }

            if (typeof that.onRemoveFilterCallback[hash] !== 'undefined') {
                that.onRemoveFilterCallback[hash].call(null);
                this.toggleNewFilterArea();
            }
        },

        /*
         *	Метод для вызова callback
         *	@param {string} hash
         *	@param {string} event
         */
        trigger: function (hash, doOnFilter) {
            var that = this;
            if (doOnFilter == undefined) {
                doOnFilter = true;
            } else {
                doOnFilter = false;
            }

            //console.log('filter trigger');
            //console.log(doOnFilter);

            this.countSelected(hash);

            if (isArray(that.callback[hash])) {
                _.each(that.callback[hash], function (callback) {
                    if (isFunction(callback)) {
                        callback.call(null, that.values[hash]);
                    }
                });
            }

            if (doOnFilter) {
                if (typeof (that.onFilterCallback[hash]) != 'undefined') {
                    that.onFilterCallback[hash].call(null);
                }
            }
        },

        countSelected(hash) {
            var that = this;
            var groups = [];

            _.each(that.items[hash], function (item, key) {
                if (!item.parent) {
                    groups.push({
                        hidden: item.hidden,
                        counter: 0,
                        items: []
                    });
                }
            });

            var counter = function (obj) {
                if (typeof obj == 'string') {
                    var values = that.get_value(hash, {
                        hidden: obj
                    });

                    if (_.isArray(values)) {
                        if (values.length == 0) {
                            return 0;
                        } else {
                            if (that.items[hash][obj].type == 'select') {
                                var list = [];
                                var values2 = _.compact(values);
                                _.each(values2, function (v) {
                                    list.push({
                                        id: v.id,
                                        hidden: v.hidden,
                                        counter: 1
                                    });
                                });

                                return counter(list);
                            } else {
                                return _.compact(values).length;
                            }
                        }
                    } else if (values) {
                        return 1;
                    }
                } else if (isArray(obj)) {
                    var s = 0;
                    _.each(obj, function (obj_item) {
                        s += counter(obj_item);
                    });
                    return s;
                } else {
                    if (that.items[hash][obj.hidden].child) {
                        var cvalues = _.clone(that.get_value(hash, {
                            hidden: that.items[hash][obj.hidden].child,
                            parent: obj.id
                        }));
                        if (cvalues && cvalues.length == 0) {
                            return obj.counter;
                            //return obj;
                        } else {
                            var cvalues2 = [];
                            var cvalues3 = _.compact(cvalues);
                            _.each(cvalues3, function (cvalue) {
                                var cv2 = _.clone(cvalue);
                                //cv2.text = obj.text + ' -> ' + cv2.text;
                                cv2.parent = obj.id;
                                cv2.counter = cv2.counter || 0;
                                cv2.counter += obj.counter;
                                cvalues2.push(cv2);
                            });
                            return obj.counter + counter(cvalues2);
                        }
                    } else {
                        return obj.counter || 0;
                    }
                }
            };

            var foo = function (obj) {
                if (typeof obj === 'string') {
                    var values = that.get_value(hash, {
                        hidden: obj
                    });

                    if (_.isArray(values)) {
                        if (_.compact(values).length > 0) {
                            if (!that.items[hash][obj].custom && that.items[hash][obj].type == 'select') {
                                return foo(values);
                            } else {
                                return [{
                                    hidden: obj,
                                    text: isFunction(that.items[hash][obj].formatter) ?
                                        that.items[hash][obj].formatter.call(that.items[hash][obj], values) :
                                        values.join('-')
                                }];
                            }
                        } else {
                            return [];
                        }
                    } else {
                        return values
                    }

                } else if (isArray(obj)) {
                    var xxx = [];
                    var array = _.compact(obj);

                    _.each(array, function (obj_item) {
                        var foo_a = foo(obj_item);
                        xxx = xxx.concat(foo_a);
                    });
                    return xxx;
                } else {
                    if (that.items[hash][obj.hidden].child) {
                        var cvalues = _.compact(that.get_value(hash, {
                            hidden: that.items[hash][obj.hidden].child,
                            parent: obj.id
                        }));
                        if (cvalues.length == 0) {
                            return obj;
                        } else {
                            var cvalues2 = [];
                            var cvalues3 = _.compact(cvalues);
                            _.each(cvalues3, function (cvalue) {
                                var cv2 = _.clone(cvalue);
                                cv2.text = obj.text + ' -> ' + cv2.text;
                                cv2.parent = obj.id;

                                cvalues2.push(cv2);
                            });
                            return foo(cvalues2);
                        }
                    } else {
                        return obj;
                    }
                }
            };

            var summa = 0;
            _.each(groups, function (group, i) {
                if (that.values[hash] == undefined) {
                    return;
                }

                if (that.values[hash].hasOwnProperty(group.hidden)) {
                    var lc = counter(group.hidden);
                    var items_selected = foo(group.hidden);

                    var fm = that.collection[hash].findWhere({
                        hidden: group.hidden
                    });
                    if (fm) {
                        that.collection[hash].findWhere({
                            hidden: group.hidden
                        }).set('counter', lc);
                    }

                    summa += _.isArray(items_selected) ? _.compact(items_selected).length : items_selected ? 1 : 0;
                } else {
                    var fm = that.collection[hash].findWhere({
                        hidden: group.hidden
                    });
                    if (fm) {
                        that.collection[hash].findWhere({
                            hidden: group.hidden
                        }).set('counter', 0);
                    }
                }
            });

            this.selected[hash] = summa;
            this.collection[hash] && this.collection[hash].findWhere({
                hidden: 'filters_selected'
            }).set('counter', summa);
        },

        /*
         *	Метод для установки активного фильтра(текущего)
         *	@param {string} cid
         *		cid модели в коллекции полей фильтра
         */
        set_filter_active: function (hash, cid) {
            var that = this;
            _.each(that.collection[hash].models, function (model) {
                model.set('active', 0);
            });
            that.collection[hash].get(cid).set('active', 1);
        },

        /*
         *	Методя для отображения текущих выбранных фильтров
         *	@param {string} hash
         *	@param {object} options
         */
        get_current_filter: function (hash) {
            var that = this;
            var groups = [];

            _.each(that.items[hash], function (item, key) {
                if (!item.parent) {
                    groups.push({
                        group_title: item.title,
                        hidden: item.hidden,
                        items: []
                    });
                }
            });

            var foo = function (obj) {
                if (typeof obj === 'string') {
                    var values = that.get_value(hash, {
                        hidden: obj
                    });

                    if (_.isArray(values)) {
                        if (_.compact(values).length > 0) {
                            if (that.items[hash][obj].type == 'select') {
                                return foo(values);
                            } else {
                                return [{
                                    hidden: obj,
                                    text: isFunction(that.items[hash][obj].formatter) ?
                                        that.items[hash][obj].formatter.call(that.items[hash][obj], values) :
                                        values.join('-')
                                }];
                            }
                        }
                    } else {
                        return values;
                    }

                } else if (isArray(obj)) {
                    var xxx = [];
                    var array = _.compact(obj);

                    _.each(array, function (obj_item) {
                        var foo_a = foo(obj_item);
                        xxx = xxx.concat(foo_a);
                    });
                    return xxx;
                } else {
                    if (that.items[hash][obj.hidden].child) {
                        var cvalues = _.compact(that.get_value(hash, {
                            hidden: that.items[hash][obj.hidden].child,
                            parent: obj.id
                        }));
                        if (cvalues.length == 0) {
                            return obj;
                        } else {
                            var cvalues2 = [];
                            var cvalues3 = _.compact(cvalues);
                            _.each(cvalues3, function (cvalue) {
                                var cv2 = _.clone(cvalue);
                                cv2.text = obj.text + ' -> ' + cv2.text;
                                cv2.parent = obj.id;

                                cvalues2.push(cv2);
                            });
                            return foo(cvalues2);
                        }
                    } else {
                        return obj;
                    }
                }
            };

            var g = [];
            _.each(groups, function (group, i) {
                if (that.values[hash].hasOwnProperty(group.hidden)) {
                    group.items = foo(group.hidden);
                    if (_.compact(group.items).length > 0) {
                        g.push(group);
                    }
                }
            });

            return g;
        },

        get_json: function (hash) {
            var that = this;

            return that.values[hash];
        },
        set_json: function (hash, json) {
            this.values[hash] = json;
            this.countSelected(hash)
        },

        /**
         *   function as_backend()
         */
        as_backend: function (hash) {
            var that = this;
            var filter = [];
            var main = [];

            _.each(that.items[hash], function (item) {
                if (!item.parent) {
                    main.push(item.hidden);
                }
            });

            if (_.compact(main).length > 0) {
                var recurse_make = function (hidden, parent) {
                    //console.log('---------------');

                    var ret = [];
                    parent = parent || false;
                    if (that.values[hash] && that.values[hash].hasOwnProperty(hidden)) {

                        if (isArray(that.values[hash][hidden])) {

                            if (that.items[hash][hidden].type == 'select') {
                                if (!parent) {
                                    _.each(that.values[hash][hidden], function (obj, i) {
                                        if (isObject(obj)) {
                                            ret.push({
                                                hidden: hidden,
                                                index: i,
                                                value: obj.id,
                                                original_object: obj
                                            });

                                            if (that.items[hash][hidden].child) {
                                                ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj.id));
                                            }
                                        }
                                    });
                                } else {
                                    _.each(that.values[hash][hidden], function (obj, i) {
                                        if(obj.parent == parent) {
                                            ret.push({
                                                hidden: hidden,
                                                parent: parent,
                                                value: obj.id,
                                                original_object: obj
                                            });
                                            if (that.items[hash][hidden].child) {
                                                ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj.id));
                                            }
                                        }
                                    });
                                    //for (var obj_parent in that.values[hash][hidden]) {
                                    //    if (that.values[hash][hidden].hasOwnProperty(obj_parent)) {
                                    //        var obj = that.values[hash][hidden][obj_parent];
                                    //        _.each(obj, function (obj_item, j) {
                                    //            if (isObject(obj_item)) {
                                    //                ret.push({
                                    //                    hidden: hidden,
                                    //                    parent: obj_parent,
                                    //                    value: obj_item.id,
                                    //                    original_object: obj_item
                                    //                });
                                    //                if (that.items[hash][hidden].child) {
                                    //                    ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj_item.id));
                                    //                }
                                    //            }
                                    //        });
                                    //    }
                                    //}
                                }
                            } else {
                                _.each(that.values[hash][hidden], function (value, i) {
                                    ret.push({
                                        hidden: hidden,
                                        index: i,
                                        value: value,
                                        original_object: value
                                    });
                                });
                            }
                        } else {
                            //console.log('isArray: FAIL');
                        }
                    }
                    return ret;
                };
                _.each(main, function (section) {
                    filter = filter.concat(recurse_make(section));
                });
            }
            //console.log(that.values[ hash ]);
            // that.set_value(hash, {
            //     value: {
            //         id      : data.id,
            //         text    : data.text,
            //         hidden  : select.hidden
            //     },
            //     parent: (parent ? parent.id : false)
            // });

            var filterItems = that.items[hash];
            //console.log('items: ', that.items[ hash ]);
            //console.log('as_backend: ', filter);

            var json_list = [];
            if (filter.length && filter.length > 0) {
                _.each(filter, function (item, index) {
                    var tmp = {
                        type: filterItems[item.hidden].type,
                        value: {},
                        parent: false
                    };
                    var obj = item.original_object;

                    if (filterItems[item.hidden].type == 'date') {
                        tmp.value = {
                            text: obj,
                            index: item.index,
                            hidden: item.hidden
                        };

                        if(that.values[ hash ][ item.hidden + '_configuration' ] !== 'undefined'){
                            json_list.push({
                                type: item.hidden + '_configuration',
                                parent: item.hidden,
                                value: that.values[ hash ][ item.hidden + '_configuration' ]
                            });
                        }

                        json_list.push(tmp);
                    } else if (filterItems[item.hidden].type == 'select') {
                        tmp.value = {
                            id: obj.id,
                            hidden: item.hidden,
                            text: obj.text
                        };
                        if (item.index !== undefined) {
                            tmp.value.index = item.index;
                        }
                        tmp.parent = (obj.parent !== undefined) ? obj.parent : false;
                        json_list.push(tmp);
                    } else {
                        tmp.value = {
                            text: obj,
                            index: item.index,
                            hidden: item.hidden
                        };
                        json_list.push(tmp);
                    }
                    // if(filterItems[ item.hidden ].type == 'select'){
                    //     tmp.value.hidden    = item.hidden;
                    //     tmp.value.text      =
                    // }
                });
            }

            //console.log('filter_items:', json_list);
            //console.log('filter json:', JSON.stringify(json_list));
            return json_list;
        },

        set_saved: function (hash, filter) {
            var that = this;

            if (!isArray(filter)) {
                filter = $.parseJSON(filter);
            }
            that.values[hash] = that.values[hash] || {};
            if (filter.length && filter.length > 0) {
                _.each(filter, function (item, index) {

                    // console.log('set saved item: ', item);

                    if(item.type.indexOf('_configuration') !== -1){
                        that.values[ hash ][ item.type ] = item.value;
                    }else{
                        that.set_value(hash, item, false);
                    }
                });
            }
            //that.trigger(hash);
        },

        /*
         *	Метод для получения выбранных фильтров
         *	для применения к ajax запросу
         */
        as_string: function (hash, as_json) {
            var that = this;
            var filter = [];
            var main = [];

            _.each(that.items[hash], function (item) {
                if (!item.parent) {
                    main.push(item.hidden);
                }
            });

            if (_.compact(main).length > 0) {
                var recurse_make = function (hidden, parent) {
                    //console.log('---------------');

                    var ret = [];
                    parent = parent || false;
                    if (that.values[hash] && that.values[hash].hasOwnProperty(hidden)) {

                        if (isArray(that.values[hash][hidden])) {

                            if (that.items[hash][hidden].type == 'select') {
                                if (!parent) {
                                    _.each(that.values[hash][hidden], function (obj, i) {
                                        if (isObject(obj)) {
                                            var filterValue = {
                                                hidden: hidden,
                                                index: i,
                                                value: obj.id
                                            };
                                            if (['leads', 'deals', 'statistic'].indexOf(hash) >= 0 && ['<>', '=', '<', '>'].indexOf(filterValue.value) >= 0) {
                                                filterValue.index = 'operator';
                                            }
                                            ret.push(filterValue);

                                            if (that.items[hash][hidden].child) {
                                                ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj.id));
                                            }
                                        }
                                    });
                                } else {
                                    _.each(that.values[hash][hidden], function (obj, i) {
                                        if(obj && obj.parent == parent) {
                                            var filterValue = {
                                                hidden: hidden,
                                                parent: parent,
                                                value: obj.id,
                                                original_object: obj
                                            };
                                            if (['leads', 'deals', 'statistic'].indexOf(hash) >= 0 && ['<>', '=', '<', '>'].indexOf(filterValue.value) >= 0) {
                                                filterValue.index = 'operator';
                                            }
                                            ret.push(filterValue);
                                            if (that.items[hash][hidden].child) {
                                                ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj.id));
                                            }
                                        }
                                    });
                                    //for (var obj_parent in that.values[hash][hidden]) {
                                    //    if (that.values[hash][hidden].hasOwnProperty(obj_parent)) {
                                    //        var obj = that.values[hash][hidden][obj_parent];
                                    //        _.each(obj, function (obj_item, j) {
                                    //            if (isObject(obj_item)) {
                                    //                ret.push({
                                    //                    hidden: hidden,
                                    //                    parent: obj_parent,
                                    //                    value: obj_item.id
                                    //                });
                                    //                if (that.items[hash][hidden].child) {
                                    //                    ret = ret.concat(recurse_make(that.items[hash][hidden].child, obj_item.id));
                                    //                }
                                    //            }
                                    //        });
                                    //    }
                                    //}
                                }
                            } else {
                                _.each(that.values[hash][hidden], function (value, i) {
                                    var filterValue = {
                                        hidden: hidden,
                                        index: i,
                                        value: value
                                    };
                                    if (that.items[hash][hidden].type != 'date') {
                                        if (['leads', 'deals', 'statistic'].indexOf(hash) >= 0 && ['<>', '=', '<', '>'].indexOf(filterValue.value) >= 0) {
                                            filterValue.index = 'operator';
                                        }
                                    }
                                    ret.push(filterValue);
                                });
                            }
                        } else {
                            ret = {};
                            ret[hidden] = that.values[hash][hidden];
                            return ret;
                        }
                    };
                    return ret;
                }
                _.each(main, function (section) {
                    filter = filter.concat(recurse_make(section));
                });
            }

            var str = [];
            var form_prefix;
            var fp = form_prefix = that.prefix[hash] || '';
            var form_suffix = '';
            if (form_prefix != '') {
                form_prefix += '[';
                form_suffix = ']';
            }

            if (as_json == true) {
                var index = [];
                var json = {};
                _.each(filter, function (item) {
                    if (item.hidden) {
                        if (json[item.hidden] == undefined) {
                            json[item.hidden] = {};
                        }
                        if (index[item.hidden] == undefined) {
                            index[item.hidden] = 0;
                        }
                        if (item.parent) {
                            if (json[item.hidden][item.parent] == undefined) {
                                json[item.hidden][item.parent] = [];
                            }
                            if (index[item.hidden + '_' + item.parent] == undefined) {
                                index[item.hidden + '_' + item.parent] = 0;
                            }
                            json[item.hidden][item.parent][index[item.hidden + '_' + item.parent]] = item.value;
                            index[item.hidden + '_' + item.parent]++;
                        } else if (item.index) {
                            json[item.hidden][item.index] = item.value;
                        } else {
                            json[item.hidden][index[item.hidden]] = item.value;
                            index[item.hidden]++;
                        }
                    } else {
                        json = item;
                    }
                });

                _.each(that.items[hash], function (item) {
                    if(item.type == 'date'){
                        if(that.values[ hash ] && typeof that.values[ hash ][ item.hidden + '_configuration' ] !== 'undefined'){
                            json[ item.hidden + '_configuration' ] = that.values[ hash ][ item.hidden + '_configuration' ];
                        }
                    }
                });
                return json;
            } else {
                _.each(filter, function (f) {
                    str.push('' + form_prefix + f.hidden + form_suffix + (f.parent ? ('[' + f.parent + '][]') : ('[' + f.index + ']')) + '=' + f.value);
                });

                _.each(that.items[hash], function (item) {
                    if(item.type == 'date'){
                        if(typeof that.values[ hash ][ item.hidden + '_configuration' ] !== 'undefined'){
                            str.push('' + item.hidden + '_configuration=' + that.values[ hash ][ item.hidden + '_configuration' ]);
                        }
                    }
                });
                return encodeURIComponent(str.join('&')); //encode for using in URL [Sanasol]
            }
        },

        /*
         *	Методя для получения количества выбранных фильтров
         *	@param {string} hash
         */
        get_count: function (hash) {
            var that = this;

            return that.selected[hash] || 0;
        }
    };

    return Filter;
});
